import { SITE } from '@/site';

/** Rating color utilities shared across components */

export function getRatingColor(rating: number): string {
  if (rating >= 9) return "var(--rating-classic)";
  if (rating >= 7) return "var(--rating-great)";
  if (rating >= 5) return "var(--rating-good)";
  if (rating >= 3) return "var(--rating-mediocre)";
  return "var(--rating-poor)";
}

export function getRatingGlow(_rating: number): string {
  return "none";
}

export function getRatingLabel(rating: number): string {
  if (rating >= 10) return "Classic";
  if (rating >= 8) return "Great";
  if (rating >= 6) return "Good";
  if (rating >= 4) return "Mediocre";
  return "Poor";
}

/** Format rating as "8.0" for card display */
export function formatRating(rating: number): string {
  return rating % 1 === 0 ? `${rating}.0` : rating.toFixed(1);
}

/** Shorten genre labels for compact display: "Hardcore Genre" → "Hardcore" */
export function shortenGenre(genre: string): string {
  return SITE.shortGenreSuffixes.reduce(
    (label, suffix) => (label.toLowerCase().endsWith(suffix.toLowerCase()) && label.length > suffix.length
      ? label.slice(0, -suffix.length)
      : label),
    genre,
  );
}

export function getRatingTailwindBg(rating: number): string {
  if (rating >= 9) return "bg-rating-classic";
  if (rating >= 7) return "bg-rating-great";
  if (rating >= 5) return "bg-rating-good";
  if (rating >= 3) return "bg-rating-mediocre";
  return "bg-rating-poor";
}